import * as React from 'react'
import { useContext } from 'react'

import CommonContext from '../../CommonContext'
import useCompleteJobPlanningController from '../../../hooks/useCompleteJobPlanningController'

type CompleteButtonProps = {
  jobPlanning: any
  reload: () => void
  setApiError: (error: any) => void
}

export default function CompleteButton(props: CompleteButtonProps) {
  const { jobPlanning, reload, setApiError } = props
  const { currentUser } = useContext(CommonContext)
  const availableMachines = currentUser.available_machines

  const { performRequest, isLoading, isAllowed, isCompleted } = useCompleteJobPlanningController(
    jobPlanning,
    currentUser,
    availableMachines,
    reload,
    setApiError
  )

  const cssClasses = 'btn btn-outline-primary complete-button'
  if (isLoading) {
    return (
      <button type="button" className={cssClasses} disabled>
        <i className="fa fa-spinner fa-spin" />
      </button>
    )
  }

  if (isAllowed) {
    const buttonTitle = isCompleted ? 'Fortryd' : 'Færdig'
    return (
      <button type="button" className={cssClasses} onClick={performRequest}>
        {buttonTitle}
      </button>
    )
  } else {
    return <>{isCompleted ? 'Afsluttet' : 'Ikke afsluttet'}</>
  }
}
